import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../../shared';
import {ProjectSettlementMethodLinkContainerModel} from '../../../../../../../models';

@Injectable({providedIn: 'root'})

export class ProjectSettlementMethodLinkService extends BaseApiTemplateService<ProjectSettlementMethodLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-settlement-method-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-settlement-method-links';
    this.httpClient = http;
  }
}
